import { useEffect, useState } from "react";

const navLinks = [
  { href: "#hero", label: "首页" },
  { href: "#beginner", label: "入门推荐" },
  { href: "#ranking", label: "排行榜" },
  { href: "#masterpiece", label: "神作盘点" },
  { href: "#reviews", label: "口碑评测" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href: string) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60" : "bg-transparent"
      }`}
    >
      <nav className="flex items-center justify-between px-4 md:px-8 h-16 md:h-18">
        <button
          onClick={() => go("#hero")}
          className="flex items-center gap-2 cursor-pointer whitespace-nowrap"
          aria-label="返回首页"
        >
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 flex items-center justify-center">
            <i className="ri-heart-2-fill text-foreground-950 text-lg md:text-xl" />
          </span>
          <span className="font-heading text-lg md:text-xl tracking-widest text-foreground-950">
            工口<em className="not-italic text-primary-500">游鉴</em>
          </span>
        </button>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => go(link.href)}
              className="px-3 py-2 rounded-md text-sm text-foreground-600 hover:text-foreground-950 hover:bg-background-200/60 transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </button>
          ))}
        </div>

        <button
          onClick={() => go("#reviews")}
          className="hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-foreground-950 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-arrow-right-up-line" />
          看最新评测
        </button>

        <button
          onClick={() => setOpen((v) => !v)}
          className="md:hidden w-10 h-10 rounded-md bg-background-200/70 flex items-center justify-center text-foreground-900 cursor-pointer"
          aria-label="打开菜单"
        >
          <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
        </button>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50/98 border-t border-background-200/60 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => go(link.href)}
              className="text-left px-3 py-2.5 rounded-md text-sm text-foreground-600 hover:text-foreground-950 hover:bg-background-200/60 transition-colors whitespace-nowrap cursor-pointer"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}